import React from 'react';

import {secondsToFormattedString} from 'shared/lib/datetime';
import {useServerUptime} from 'features/server/model/useServerUptime';

interface IServerUptimeProps {
    uptimeSeconds: number | null,
    metricsTs: number | null,
    isLive: boolean,
}

const ServerUptime: React.FC<IServerUptimeProps> = ({uptimeSeconds, metricsTs, isLive}) => {
    const seconds = useServerUptime(uptimeSeconds, metricsTs, isLive);

    if (seconds === null) {
        return <>—</>;
    }

    return <>{secondsToFormattedString(seconds)}</>;
};

export default ServerUptime;
